import { ELocales } from "../../common";


export const languages = [...new Set(Object.values(ELocales).map(locale => locale))]
